<!DOCTYPE html>
<html lang="es"><head>
<meta http-equiv="content-type" content="text/html; charset=UTF-8">
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <!-- The above 3 meta tags *must* come first in the head; any other head content must come *after* these tags -->
    <title>Ralarsa</title>
    <link href="https://fonts.cdnfonts.com/css/lota-grotesque-alt-1" rel="stylesheet">
  </head>
  <body>
    <div class="recuadro-login">
      <form method="GET" action="javascript:void(0);">
        <div>
          <input type="text" id="user" name="user" required="required" placeholder="Usuario" (keydown)="onKeyDown($event)">
        </div>
        <br>
        <div>
          <input type="password" maxlength="254" name="password" required="required" placeholder="Contraseña" id="pass" (keydown)="onKeyDown($event)">
        </div>

        <button (click)="getValoresCampos()"  class="btnMenu" name="login" value="Iniciar Sesión">Iniciar sesión</button>
        
      </form>
    </div>
  </body>
</html>
